<template>
  <div class="box2">
    <pageTitle
      title="AI时代<br/>软件开发人才需求爆发式增长"
      text=""
    />

    <div class="subject-box">
      <img src="../../../assets/coursePage/java/box2/2.png"/>
    </div>
    <a class="btn"  @click="zixun">工程师的发展方向</a>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
export default {
  components: {
    pageTitle,
  },
  data() {
    return {

    };
  },
   methods:{
    zixun(){
       this.clickZiXun()
    }
  }
};
</script>

<style lang="less" scoped>
.box2 {
  padding: 80px 0;
  width: 100%;
  background: url("../../../assets/coursePage/java/box2/bgc.png") no-repeat;
  background-size: cover;
  .subject-box {
   width: 100%;
  overflow-x: auto;
  img{
    width: 3154px;
    margin: 48px 0 48px 32px;
  }
  }
  .btn{
    width: 480px;
height: 88px;
display: block;
margin:0 auto;
background: linear-gradient( 270deg, #FF7A87 0%, #FF4659 100%);
border-radius: 48px;
font-family: PingFangSC, PingFang SC;
font-weight: 500;
font-size: 30px;
color: #FFFFFF;
line-height: 88px;
text-align: center;
font-style: normal;
  }

 
}
</style>
